import { createContext } from 'react';

import type { ConfigKey, MapConfigState } from '@/types';

interface MapConfigContextType {
  config: MapConfigState;
  isLoading: boolean;
  handleToggle: (key: ConfigKey) => Promise<void>;
  handleReset: () => Promise<void>;
}

export const MapConfigContext = createContext<MapConfigContextType | undefined>(undefined);
